var _tspan;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 12.7 12.7",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    strokeLinejoin: "bevel"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("g", {
    strokeWidth: 0.72263
  }, /*#__PURE__*/React.createElement("path", {
    d: "m.040244 6.344h1.6698c2.3041 0 2.1142-1.9301 4.612.00621 2.4979 1.9363.59159-.22195 4.5491-.054781h1.5653",
    stroke: "#ffc051",
    style: {
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.666 8.1014h-1.809c-3.9575-.16716-2.0512 1.9911-4.5491.054781-2.4979-1.9363-2.1679.041583-4.4721.041583h-1.5409",
    stroke: "#f86",
    style: {
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m.034247 9.9675h1.6698c2.3041 0 2.1142-1.9301 4.612.00621 2.0848 1.6161 1.1017.37994 3.0203.024052.38018-.070522.87429-.10648 1.5288-.078832h1.5718",
    stroke: "#fd604d",
    style: {
      paintOrder: "normal"
    }
  })), /*#__PURE__*/React.createElement("path", {
    transform: "scale(1,-1)",
    d: "m10.63-5.2854a4.2801 4.312 0 01-4.2801 4.312 4.2801 4.312 0 01-4.2801-4.312",
    stroke: "#ffe577",
    strokeOpacity: 0.99542,
    strokeWidth: 0.62924,
    style: {
      paintOrder: "normal"
    }
  })), /*#__PURE__*/React.createElement("text", {
    x: 4.4577012,
    y: 4.8257666,
    fill: "#000000",
    fontSize: "3.175px",
    strokeWidth: 0.10583,
    style: {
      paintOrder: "normal"
    },
    xmlSpace: "preserve"
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: 4.4577012,
    y: 4.8257666,
    fill: "#000000",
    fontFamily: "Ubuntu"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.1ad4aabf7d51f28388cc69c87bbd4da5.svg";
export { ForwardRef as ReactComponent };